export function capitalize(str) {
    return str
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
}
export function assertNever(_, message) {
    throw new Error(message);
}
export function getWalletConnectParams(walletConnectAuthConfig) {
    if (!walletConnectAuthConfig)
        return undefined;
    return walletConnectAuthConfig
        ? {
            ...walletConnectAuthConfig,
            qrModalOptions: {
                ...walletConnectAuthConfig.qrModalOptions,
                themeVariables: {
                    "--wcm-z-index": "1000000",
                    ...walletConnectAuthConfig.qrModalOptions?.themeVariables,
                },
            },
        }
        : undefined;
}
//# sourceMappingURL=utils.js.map